import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table, Badge } from "react-bootstrap";
import { Button } from "reactstrap";
import { useParams } from "react-router-dom";
import Select from "react-select";
import toast from "react-hot-toast";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { apiurl } from "../../../common/Helpers";

const ManageCoupon = () => {
  const { id,eventname } = useParams();
    console.log("Organizer ID:", eventname);
  /* ===== FAKE EVENT HEADER DATA ===== */
  const eventInfo = {
    name: "Music Night 2026",
    startDate: "12 Feb 2026",
  };
const [selecteventForp, setselecteventForp] = useState({
  value: id,
  label: eventname,
});
  /* ================= STATE ================= */
  const [name, setname] = useState("");
  const [type, setType] = useState("percentage");
  const [discount, setdiscount] = useState("");
  const [eventvalue, seteventvalue] = useState("");
  const [eventlabel, seteventlabel] = useState("");
  const [limitType, setLimitType] = useState("unlimited");
  const [limitNumber, setLimitNumber] = useState("");

  const [Upid, setUpid] = useState("");
  const [BtnLoader, setBtnLoader] = useState(false);

  const [eventList, setEventList] = useState([]);
  const [selecteventFor, setselecteventFor] = useState(null);

  const [couponList, setCouponList] = useState([]);

  /* ================= FETCH EVENTS ================= */
const globalTicketType = {
  value: 1, 
   label: 'Global Ticket'
};

const FetchEvents = async () => {
  try {
    const res = await fetch(apiurl + "event/event-ticket-type-list", { 
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventid:id }),
    });

    const data = await res.json();

    if (data.data && data.data[0] && data.data[0].allprice) {
        console.log("FetchEvents data:", data.data);
       const transformedEvents = data.data[0].allprice.map(ticket => ({
                                value: ticket.id,    // Use `id` as value
                                label: ticket.name   // Use `name` as label
        }));
      // Combine with global ticket at the top
      const combinedEvents = [globalTicketType, ...transformedEvents];
      setEventList(combinedEvents);
    } else {
      toast.error("No events available.");
      setEventList([globalTicketType]); // still show global ticket
    }
  } catch (error) {
    console.error("FetchEvents error:", error);
    toast.error("Error fetching events: " + error.message);
    setEventList([globalTicketType]); // fallback
  }
};

  /* ================= FETCH COUPONS ================= */
  const FetchCoupons = async () => {
    const res = await fetch(apiurl + "admin/organaizer-coupon-event-list", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    const data = await res.json();
    if (data.success) setCouponList(data.data);
  };

  useEffect(() => {
    FetchEvents();
    FetchCoupons();
  }, []);

  /* ================= CREATE / UPDATE ================= */
  const HandelCreateCoupon = async () => {
    if (!name || !discount || !selecteventFor) {
      return toast.error("Please fill required fields");
    }
      if (limitType === "limited" && (!limitNumber || limitNumber <= 0)) {
    return toast.error("Please enter limit number for limited coupons");
  }
  if (discount > 40) {
    return toast.error("Discount cannot be more than 40%");
  }
    setBtnLoader(true);

    const payload = {
      upid: Upid || null,
      name,
      type,
      discount,
      limitType,
      limitNumber: limitType === "limited" ? limitNumber : null,
      eventvalue: selecteventForp.value || null,
      eventlabel: selecteventForp.label || null,
      ticketvalue: selecteventFor.value || null,
      ticketlabel: selecteventFor.label || null,
      totaluse:0,
      is_organizer:1,
    };    
    const res = await fetch(apiurl + "admin/orgaizer-coupon-event-insert", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    if (data.success) {
      console.log("Coupon saved:", data);
      toast.success("Coupon saved successfully");
      resetForm();
      FetchCoupons();
    }
    setBtnLoader(false);
  };

  /* ================= EDIT ================= */
  const handleEdit = (item) => {
    setUpid(item._id);
    setname(item.name);
    setType(item.type);
    setdiscount(item.discount);
    setLimitType(item.limitType || "unlimited");
    setLimitNumber(item.limitNumber || "");
    setselecteventFor({
      value: item.eventvalue,
      label: item.eventlabel,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this coupon?")) return;
    await fetch(apiurl + "admin/coupon-event-delete", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    toast.success("Coupon deleted");
    FetchCoupons();
  };

  const resetForm = () => {
    setUpid("");
    setname("");
    setType("percentage");
    setdiscount("");
    setLimitType("unlimited");
    setLimitNumber("");
    setselecteventFor(null);
  };

  /* ================= UI ================= */
  return (
    <div className="content-body coupon-page">
      <div className="container-fluid">

        {/* ===== EVENT HEADER ===== */}
        <Card className="border-0 shadow-sm rounded-4 mb-4">
          <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
            <div>
              <h4 className="fw-bold mb-1">{eventname}</h4>           
            </div>
            <Badge bg="success" className="px-3 py-2">
              Active Event
            </Badge>
          </Card.Body>
        </Card>

        <Row className="g-4">

          {/* ===== LEFT FORM ===== */}
          <Col lg={5} md={12}>
            <Card className="border-0 shadow-sm rounded-4">
              <Card.Header className="bg-white border-0">
                <h5 className="fw-bold mb-0">
                  {Upid ? "Edit Coupon" : "Create Coupon"}
                </h5>
              </Card.Header>

              <Card.Body>
                <label className="fw-semibold mb-1">Coupon Name</label>
                <input
                  className="form-control mb-3"
                  placeholder="NEWYEAR50"
                  value={name}
                  onChange={(e) => setname(e.target.value)}
                />

                <Row className="g-3 mb-3">               
                  <Col md={12}>
                    <label className="fw-semibold mb-1">Discount %</label>
                    <input
                      className="form-control"
                      value={discount}
                      onChange={(e) => setdiscount(e.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="g-3 mb-3">
                  <Col md={6}>
                    <label className="fw-semibold mb-1">Usage Limit</label>
                    <select
                      className="form-select"
                      value={limitType}
                      onChange={(e) => setLimitType(e.target.value)}
                    >
                      <option value="unlimited">Unlimited</option>
                      <option value="limited">Limited</option>
                    </select>
                  </Col>

                  {limitType === "limited" && (
                    <Col md={6}>
                      <label className="fw-semibold mb-1">Limit Count</label>
                      <input
                        className="form-control"
                        value={limitNumber}
                        onChange={(e) => setLimitNumber(e.target.value)}
                      />
                    </Col>
                  )}
                </Row>

                <label className="fw-semibold mb-1">Tickets</label>
                <Select
                  value={selecteventFor}
                  onChange={setselecteventFor}
                  options={eventList}
                />

                <Button
                  color="primary"
                  className="w-100 mt-4"
                  disabled={BtnLoader}
                  onClick={HandelCreateCoupon}
                >
                  {BtnLoader ? "Saving..." : Upid ? "Update Coupon" : "Create Coupon"}
                </Button>
              </Card.Body>
            </Card>
          </Col>

          {/* ===== RIGHT LIST ===== */}
          <Col lg={7} md={12}>
            <Card className="border-0 shadow-sm rounded-4">
              <Card.Header className="bg-white border-0">
                <h5 className="fw-bold mb-0">Coupon List</h5>
              </Card.Header>

              <Card.Body className="table-responsive">
                <Table hover className="align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Discount</th>
                      <th>Limit</th>
                      <th>Event</th>
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {couponList.map(item => (
                      <tr key={item._id}>
                        <td className="fw-semibold">{item.name}</td>
                        <td>
                          {item.type === "percentage"
                            ? `${item.discount}%`
                            : `₹${item.discount}`}
                        </td>
                        <td>
  {item.limitType === "limited" ? (
    <>
      {item.limitNumber}
    </>
  ) : (
    "Unlimited"
  )}
</td>

                        <td>{item.eventlabel}</td>
                        <td className="text-end">
                          <Button
                            size="sm"
                            color="light"
                            className="me-2"
                            onClick={() => handleEdit(item)}
                          >
                            <FiEdit2 />
                          </Button>
                          <Button
                            size="sm"
                            color="light"
                            onClick={() => handleDelete(item._id)}
                          >
                            <FiTrash2 className="text-danger" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </div>
    </div>
  );
};

export default ManageCoupon;
